import { render, staticRenderFns } from "./RecordModal.html?vue&type=template&id=4ec42e86&scoped=true&"
import script from "./RecordModal.vue?vue&type=script&lang=js&"
export * from "./RecordModal.vue?vue&type=script&lang=js&"
import style0 from "./RecordModal.scss?vue&type=style&index=0&id=4ec42e86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec42e86",
  null
  
)

export default component.exports